import { CircularProgress } from '@mineral/core';
import { Page } from 'components/Page';
import React from 'react';

const LoadingScreenComp: React.FC = () => {
  return (
    <Page title="" sx={{ height: '100%' }}>
      <CircularProgress sx={{ marginLeft: '45%', marginTop: '18%' }} />
    </Page>
  );
};

export default LoadingScreenComp;
